export default {
  siteUnitEvents: [],
  errors: null
};
